import { render, staticRenderFns } from "./issues.vue?vue&type=template&id=51a1bd55&scoped=true&"
import script from "./issues.vue?vue&type=script&lang=js&"
export * from "./issues.vue?vue&type=script&lang=js&"
import style0 from "./issues.vue?vue&type=style&index=0&lang=css&"
import style1 from "./issues.vue?vue&type=style&index=1&id=51a1bd55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1bd55",
  null
  
)

export default component.exports